<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>admin_panel_settings</mat-icon></div>
      <div><h2 class="ud-title">Change role</h2><div class="ud-subtitle">Update this user’s access and permissions</div></div>
    </div>
    <button mat-icon-button class="ud-close" (click)="close()" [disabled]="saveClick" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <form id="updateUserRole" class="ud-body" (ngSubmit)="save()">
    <div class="ud-context"><mat-icon>person_outline</mat-icon><span>{{ email }}</span></div>
    <div class="ud-field">
      <label class="ud-label">Role <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><mat-select [(value)]="selectedRole" placeholder="Choose a role">@for (role of roles; track role.id) { <mat-option [value]="role.id">{{role.name}}</mat-option> }</mat-select></mat-form-field>
      <p class="ud-help">New permissions take effect the next time the user’s claims are refreshed.</p>
    </div>
  </form>
  <div class="ud-footer">
    <button mat-button class="ud-btn-ghost" (click)="close()" [disabled]="saveClick">Cancel</button>
    <button type="submit" form="updateUserRole" class="ud-btn-primary" [disabled]="saveClick || !selectedRole">
      @if (saveClick) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>Update role</span><mat-icon>check</mat-icon> }
    </button>
  </div>
</div>
